import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { NegotiationStatus } from "@/modules/candidate/constants/negotiationStatus"
import { SpaceType } from "@/modules/candidate/constants/spaceType"
import { UserModel } from "@/modules/users/models/userModel"

export interface ExtensionOfferData {
  uid: string
  status: NegotiationStatus
  endDate: string
  priceValue: number
  priceValueCurrency?: string
  localPriceValue?: number
  localPriceValueCurrency?: string
  maxHoursInContract?: number
  message: string
  proposeReplacement: boolean
  created: string
  updated: string
  origin: SpaceType
  proposer?: UserModel | null
  respondedBy?: UserModel | null
  respondedMessage?: string
}

@Serializable
export class ExtensionOfferModel {
  uid: string = ""
  status: NegotiationStatus = NegotiationStatus.NotDefined
  endDate: string = ""
  priceValue: number = 0
  priceValueCurrency: string = ""
  localPriceValue: number = 0
  localPriceValueCurrency: string = ""
  maxHoursInContract: number = 0
  message: string = ""
  proposeReplacement: boolean = false
  created: string = ""
  updated: string = ""
  origin: SpaceType = SpaceType.NotDefined
  proposer: UserModel | null = null
  respondedBy: UserModel | null = null
  respondedMessage: string = ""

  constructor(data: ExtensionOfferData | null = null) {
    if (data) {
      this.uid = data.uid ?? ""
      this.status = data.status ?? NegotiationStatus.NotDefined
      this.endDate = data.endDate ?? ""
      this.priceValue = data.priceValue ?? 0
      this.priceValueCurrency = data.priceValueCurrency ?? ""
      this.localPriceValue = data.localPriceValue ?? 0
      this.localPriceValueCurrency = data.localPriceValueCurrency ?? ""
      this.maxHoursInContract = data.maxHoursInContract ?? 0
      this.message = data.message ?? ""
      this.proposeReplacement = data.proposeReplacement ?? false
      this.created = data.created ?? ""
      this.updated = data.updated ?? ""
      this.origin = data.origin ?? SpaceType.NotDefined
      this.proposer = data.proposer ? new UserModel(data.proposer) : null
      this.respondedBy = data.respondedBy
        ? new UserModel(data.respondedBy)
        : null
      this.respondedMessage = data.respondedMessage ?? ""
    }
  }
}
